import { plainToInstanceWithLVS } from '@goparrot/common';
import { BaseFacade } from '../../common';
import { ReadOrderConfigDto } from '../../order';
import { OrderConfigExposeGroup } from '../interface';
export class OrderConfigFacade extends BaseFacade {
    async create(storeId, payload) {
        const url = `api/v2/stores/${storeId}/configs`;
        return plainToInstanceWithLVS(ReadOrderConfigDto, (await this.client.post(url, payload)).data, { groups: [OrderConfigExposeGroup.READ] });
    }
    async get(storeId) {
        const url = `api/v2/stores/${storeId}/configs`;
        return plainToInstanceWithLVS(ReadOrderConfigDto, (await this.client.get(url)).data, { groups: [OrderConfigExposeGroup.READ] });
    }
    async patch(storeId, operations) {
        const url = `api/v2/stores/${storeId}/configs`;
        return plainToInstanceWithLVS(ReadOrderConfigDto, (await this.client.patch(url, operations)).data, { groups: [OrderConfigExposeGroup.READ] });
    }
    async delete(storeId) {
        await this.client.delete(`api/v2/stores/${storeId}/configs`);
    }
}
//# sourceMappingURL=OrderConfigFacade.js.map